export default "__VITE_ASSET__f5yrKyc8__"